import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';

import { decryptResponse } from 'utils/token';

type GetPartnerDocumentsProps = {
  partnerId: string;
};

export const getPartnerDocuments =
  ({ partnerId }: GetPartnerDocumentsProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { partnerId } };
    try {
      const { data } = await axiosV2.get(`/partners/documents`, query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
